module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0023.jpg?v=cf79871b";